import { render } from "./header.vue?vue&type=template&id=0bc8bf0a&scoped=true&lang=pug"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=0bc8bf0a&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=1&id=0bc8bf0a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc8bf0a"]])

export default __exports__